import { createActions } from "redux-actions";

const actions = createActions({
    UPDATE_STATIONS: (data) => ({data}),
    GET_DOCUMENT_INFO: (data)=>({data}),
    SAVE_DOCUMENT_INFO: (data)=>({data}),
    UPDATE_STATION: (data) => ({data})
})

export const updateStations = actions.updateStations;
export const getDocumentInfo = actions.getDocumentInfo;
export const saveDocumentInfo = actions.saveDocumentInfo;
export const updateStation = actions.updateStation;